import { Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";

export const Page2 = () => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>2.1.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний хугацаа нь Талууд харилцан тохиролцож байгуулсан
            өдрөөс эхлэн 3 /гурван/ жилийн хугацаатай байна.
          </Text>
        </View>
        <View style={[styles.spaceX]}>
          <Text>2.2.</Text>
          <Text style={styles.text}>
            Гэрээний хугацаа дуусахаас 1 сарын өмнө талуудын аль нэг нь гэрээг
            дуусгавар болгох санал гаргаагүй тохиолдолд Гэрээг дахин 3 жилийн
            хугацаагаар сунгагдсанд тооцно.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 16 },
          ]}
        >
          ГУРАВ. ГЭРЭЭНИЙ ТӨЛБӨРИЙН НӨХЦӨЛ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>3.1.</Text>
          <Text style={styles.text}>
            Эрх олгогчийн бүтээлийг Гэрээний 1.2.5-д зааснаас бусад аргуудаар
            түгээх, түрээслэх, ашиглах үнийг М Мюзик Дистрибюшн тогтоох ба үүнд
            худалдах, түрээслэх, багц хэлбэрээр худалдах болон урьдчилан
            захиалах үнэ хамаарна.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>3.2.</Text>
          <Text style={styles.text}>
            М Мюзик Дистрибюшн нь тодорхой хугацаатайгаар урамшуулал зарлаж,
            контентийн үнэ тарифыг өөрчилж болно. Энэ тохиолдолд бууруулсан
            үнийн дүнгээс Эрх олгогчид орлогыг хуваарилна.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>3.3.</Text>
          <Text style={styles.text}>
            Уран бүтээлийг Гэрээний 1.2-т заасан аргуудаар нийтэд түгээх,
            түрээслэхдээ М Мюзик Дистрибюшн нь Эрх олгогчид хамаарах
            үйлчилгээний орлого /НӨАТ багтаагүй дүн/-ыг дараах байдлаар сар бүр
            хуваарилна. Орлого хуваарилах дүнгийн доод хэмжээ 100 000 /нэг зуун
            мянган/ төгрөг байна.
          </Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>3.3.1. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг давхар эзэмшдэг
              бол Гэрээний 1.2.1-1.2.5-д заасан үйлчилгээнд хамаарах орлогын 70
              хувийг;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>3.3.2. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогч нь уран бүтээлийнхээ зохиогчийн эрхийг эзэмшдэггүй бол
              Гэрээний 1.2.1-1.2.5-д заасан үйлчилгээний орлогын хувьд
              зохиогчийн эрхийн төлбөрийг суутгаж үйлчилгээнд хамаарах орлогын
              50 хувийг;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>3.3.3. {""}</Text>
            <Text style={styles.subtext}>
              Гэрээний 1.2.5-д заасан үйлчилгээний орлогын хувьд талууд харилцан
              тохиролцсоны үндсэн дээр нэмэлт гэрээ /мерчандайз/ байгуулж
              бүтээгдэхүүн борлуулалтын хувь орлогыг тохиролцоно.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>3.4.</Text>
          <Text style={styles.text}>
            <Text style={styles.textBold}> Зохиогчийн эрхийн төлбөрийг</Text>{" "}
            тухайн ашиглагдаж байгаа Уран бүтээлийн зохиогчийн эрх эзэмшигч нарт
            ногдох зохиогчийн эрхийн төлбөрийг хамтын удирдлагын байгууллагатай
            байгуулсан гэрээний дагуу шилжүүлэх төлбөрийг хэлнэ.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>3.5.</Text>
          <Text style={styles.text}>
            Хэрэв Эрх олгогч нь 3.3.1-т зааснаар зохиогчийн эрхийг давхар
            эзэмшдэг бол М Мюзик Дистрибюшнтэй “Зохиогчийн эрхийн гэрээ”
            байгуулан уг төлбөрийг авч болно.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>3.6.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний дагуу Эрх олгогчийн Уран бүтээлийг 2 буюу түүнээс
            дээш уран бүтээлчид хамтран дуулсан бөгөөд тухайн бүтээлээс олсон
            орлогыг бусад уран бүтээлчидтэй хуваах шаардлагатай тохиолдолд Эрх
            олгогчийн бичгээр гаргасан хүсэлтийн дагуу хуваарилна.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>3.7.</Text>
          <Text style={styles.text}>
            Уран бүтээл ашигласны төлбөр тооцоог сар бүр гаргах бөгөөд Эрх
            олгогч нь сар бүрийн 10-ны өдрөөс хойш Татварын ерөнхий хуулийн
            28.5, Нэмэгдсэн өртгийн албан татварын тухай хуулийн 4.1.14-д заасан
            журмын дагуу төлбөрийн баримтыг татварын нэгдсэн системд илгээж
            мэдэгдэх эсхүл <Text style={styles.link}>finance@mmusic.mn</Text>{" "}
            хаяг руу илгээнэ.
          </Text>
        </View>
      </View>
    </Page>
  );
};

export default Page2;
